import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm, Tooltip } from "antd";
import { getRequest, postRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
    ErrorNotificationMsg,
    SuccessNotificationMsg,
} from "../../utils/Notifications";

const { Search } = Input;

const ArchivePickupPoint = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // const [archivedMaterialList, setArchivedMaterialList] = useState([]);
    const [archivecompanyList, setArchiveCompanyList] = useState([]);
    const [totalCount, settotalCount] = useState(0);
    const [selectedRow, setSelectedRow] = useState([]);

    const [state, setState] = useState({
        page: 1,
        ordering: "-id",
        pagesize: 10,
        search: "",
        total: 0,
    });

    useEffect(() => {
        const getMaterialArchiveList = async () => {
            setLoading(true);

            try {
                let apiResponse = await getRequest("pickup-point/archived-pickup-point-list/", state);
                if (apiResponse?.data?.results?.data) {
                    setArchiveCompanyList(apiResponse.data.results.data);
                    settotalCount(apiResponse.data.count);
                } else {
                    ErrorNotificationMsg(t("error_in_archived_pickuppoint"));
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        };
        getMaterialArchiveList();
    }, [state, t]);

    const handleTableChange = async (pagination, filters, sorter, ordering) => {
        const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
        setState({
            ...state,
            page: pagination.current,
            pagesize: pagination.pageSize,
            ordering: orderBy,
        });
    };

    const GetSortingEnumValue = (sortField, sortOrder) => {
        let sortingEnumKey = "id";

        if (sortField === "additional_detail" && sortOrder === "ascend") {
            sortingEnumKey = "additional_detail";
        }
        if (sortField === "additional_detail" && sortOrder === "descend") {
            sortingEnumKey = "-additional_detail";
        }
        if (sortField === "pincode" && sortOrder === "ascend") {
            sortingEnumKey = "pincode";
        }
        if (sortField === "pincode" && sortOrder === "descend") {
            sortingEnumKey = "-pincode";
        }

        if (sortField === "suburb" && sortOrder === "ascend") {
            sortingEnumKey = "suburb";
        }
        if (sortField === "suburb" && sortOrder === "descend") {
            sortingEnumKey = "-suburb";
        }

        if (sortField === "address" && sortOrder === "ascend") {
            sortingEnumKey = "address";
        }
        if (sortField === "address" && sortOrder === "descend") {
            sortingEnumKey = "-address";
        }

        if (sortField === "phone" && sortOrder === "ascend") {
            sortingEnumKey = "phone";
        }
        if (sortField === "phone" && sortOrder === "descend") {
            sortingEnumKey = "-phone";
        }

        if (sortField === "email" && sortOrder === "ascend") {
            sortingEnumKey = "email";
        }
        if (sortField === "email" && sortOrder === "descend") {
            sortingEnumKey = "-email";
        }
        if (sortField === "person_name" && sortOrder === "ascend") {
            sortingEnumKey = "person_name";
        }
        if (sortField === "person_name" && sortOrder === "descend") {
            sortingEnumKey = "-person_name";
        }
        if (sortField === "state" && sortOrder === "ascend") {
            sortingEnumKey = "state";
        }
        if (sortField === "state" && sortOrder === "descend") {
            sortingEnumKey = "-state";
        }
        return sortingEnumKey;
    };

    const searchCallbackDelayed = (event) => {
        const { value } = event.target;
        debounceLoadData(value, onSearch);
    };
    const onSearch = (value) => {
        setState({
            ...state,
            search: value,
        });
    };

    const debounceLoadData = debounce((value, onSearch) => {
        onSearch(value);
    }, 1000);
    const rowSelection = {
        onChange: (selectedRowKeys) => {
            setSelectedRow(selectedRowKeys);
        },
    };

    const handleRestore = async (id = "") => {
        let ids = selectedRow;
        if (ids.length === 0) {
            ids.push(id);
        }
        try {
            let apiResponse = await postRequest("pickup-point/restore-pickup-point/", {
                deleted: ids,
            });
            if (apiResponse.data.success) {
                SuccessNotificationMsg(t("pickuppoint_restore_successfully"));
                setSelectedRow([]);
                navigate("/pickup-point");
            } else {
                ErrorNotificationMsg(t("error_in_restore_pickuppoint"));
            }
        } catch (error) {
            ErrorNotificationMsg(error);
        }
    };
    // const openImageInNewTab = (imageSrc) => {
    //     window.open(imageSrc, "_blank");
    // };

    const columns = [
        {
            title: "Name",
            dataIndex: "person_name",
            key: "person_name",
            sorter: true,
            width: 100,
            render: (dataIndex) => (

                <div
                    style={{
                        maxWidth: "400px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textTransform: "none",
                    }}
                >
                    {dataIndex}
                </div>
            ),
        },

        {
            title: "E-mail",
            dataIndex: "email",
            key: "email",
            sorter: true,
            width: 200,
            render: (dataIndex) => (
                // <Tooltip
                //     color={colors}
                //     placement="left"
                //     // title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
                //     title={<span style={{ color: "#fff" }}>{dataIndex.toLowerCase()}</span>}
                // >
                    <div
                        style={{
                            maxWidth: "400px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textTransform: 'lowercase',
                        }}
                    >
                        {dataIndex.toLowerCase()}
                    </div>
                // </Tooltip>
            ),
        },
        {
            title: "Address",
            dataIndex: "address",
            key: "address",
            sorter: true,
            width: 130,
            render: (dataIndex) => (
                // <Tooltip
                //     color={colors}
                //     placement="left"
                //     title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
                // >
                    <div
                        style={{
                            maxWidth: "400px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {dataIndex}
                    </div>
                // </Tooltip>
            ),
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
            width: 180,
            render: (phone) => {
                if (phone) {
                    const cleanedPhone = String(phone).replace(/\D/g, '');

                    if (cleanedPhone.startsWith("91")) {
                        return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
                    } else if (cleanedPhone.length > 5) {
                        const countryCode = cleanedPhone.slice(0, cleanedPhone.length - 10);
                        const localNumber = cleanedPhone.slice(-10);
                        return `+${countryCode} ${localNumber.slice(0, 5)} ${localNumber.slice(5)}`;
                    } else {
                        return `+${cleanedPhone}`;
                    }
                }
                return null;
            },

            sorter: true,
        },
        {
            title: "State",
            dataIndex: "state",
            key: "state",
            sorter: true,
        },
        {
            title: "Suburb",
            dataIndex: "suburb",
            key: "suburb",
            sorter: true,
        },
        {
            title: "pincode",
            dataIndex: "pincode",
            key: "pincode",
            sorter: true,
        },
        {
            title: "Additional Detail",
            dataIndex: "additional_detail",
            key: "additional_detail",
            sorter: true,
        },
        {
            title: "Action",
            key: "operation",
            fixed: "right",
            width: 130,
            render: (text, record) => (
                <Space>
                    {/* <Tooltip
                        color={colors}
                        placement="right"
                        title={<span style={{ color: "#fff" }}>Restore</span>}
                    > */}
                        <Popconfirm
                            className="action"
                            title={t("pop_restore_title")}
                            okText={t("pop_ok")}
                            cancelText={t("pop_cancel")}
                            onConfirm={() => handleRestore(record.id)}
                        >
                            <ArchiveRestore className="ArchiverestorImg" />{" "}
                        </Popconfirm>
                    {/* </Tooltip> */}
                </Space>
            ),
        },
    ];
    const colors = ["#737373"];
    return (
        <>
            <div className="ListingTopBar">
                <div className="pagenamewrap">
                    <div className="pagename">
                        {/* <Tooltip
                            color={colors}
                            placement="right"
                            title={
                                <span style={{ color: "#fff" }}>
                                     Manage designated locations for package pickup, where customers can collect their parcels conveniently.
                                </span>
                            }
                        > */}
                            <h3>{t("Archive Pickup Point")}</h3>
                        {/* </Tooltip> */}

                        <Breadcrumb className="Breadcrumb-Sec">
                            <Breadcrumb.Item>
                                <Link to="/dashboard">{t("home")}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <Link to="/pickup-point">{t("Pickup Point")}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>{t("Archive Pickup Point")}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <Space>
                        <div className="searchwrp">
                            <Space direction="vertical">
                                <Search
                                    prefix={
                                        <img
                                            src={SearchIcon}
                                            alt="SearchIcon"
                                            className="SearchIcon"
                                            width={22}
                                        />
                                    }
                                    placeholder={t("pl_search_list")}
                                    onChange={searchCallbackDelayed}
                                    style={{
                                        width: 250,
                                    }}
                                />
                            </Space>
                        </div>
                        {selectedRow.length > 0 && (
                            <Popconfirm
                                className="action"
                                title={t("pop_restore_title")}
                                okText={t("pop_ok")}
                                cancelText={t("pop_cancel")}
                                placement="left"
                                onConfirm={() => handleRestore()}
                            >
                                <ButtonField
                                    className="BlueShadowBtn"
                                    type="primary"
                                    htmlType="button"
                                    label="Restore"
                                />
                            </Popconfirm>
                        )}
                    </Space>
                </div>
            </div>

            <section className="grid-sec">
                <div className="PR-body">
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={archivecompanyList}
                        loading={loading}
                        pagination={{
                            defaultCurrent: state.page,
                            defaultPageSize: state.pagesize,
                            total: totalCount,
                            showTotal: (total) => `Total ${total} items`,
                            showSizeChanger: true,
                            locale: {
                                items_per_page: "Items / Page", // Text for the size changer
                            },
                        }}
                        onChange={handleTableChange}
                        scroll={{ x: 1200 }}
                    />
                    <div className="FormFooter Container">
                        <ButtonField
                            className="SaveGradiantBtn"
                            type="primary"
                            htmlType="button"
                            label={t("Back To List")}
                            onClick={() =>
                                navigate(
                                    `/pickup-point`
                                )
                            }
                        //onClick={() => setCurrentIndex(0)}
                        />
                    </div>
                </div>

            </section>

        </>
    );
};

export default ArchivePickupPoint;
